<app-button
  data-cy="search-category-btn"
  class="category-button"
  [icon]="'assets/icon/book.svg'"
  [color]="'blue'"
  (clicked)="openCategoriesModal()"
  [shape]="'circle'"
  [size]="'small'" />
